import React from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { gameStore } from '../../../../store/gameStore';

import FreeSpinContent from './freeSpinContent';
import FreeSpinBackground from './freeSpinBackground';

const FreeSpinCountPopup = observer(({ containerConfig }) => {
  if (!gameStore.gameFreeSpinRemainingCount) {
    return null;
  }

  return (
    <Container {...containerConfig} name='FreeSpinCountPopup'>
      <FreeSpinBackground />
      <FreeSpinContent />
    </Container>
  );
});

export default FreeSpinCountPopup;
